import SEOAgentBridge from "@/components/SEOAgentBridge";
import type { SEOIntent } from "@/lib/seo-intents";

interface AIAstrologerCTAProps {
  context?:
    | "panchang"
    | "rashifal"
    | "kundli"
    | "matching"
    | "numerology"
    | "dosha"
    | "festival"
    | "generic";
  headline?: string;
  subhead?: string;
  currentPage?: string;
  asks?: readonly string[];
}

const CONTEXT_INTENT: Record<NonNullable<AIAstrologerCTAProps["context"]>, SEOIntent> = {
  panchang: "timing_muhurat",
  rashifal: "daily_guidance",
  kundli: "chart_report",
  matching: "chart_report",
  numerology: "chart_report",
  dosha: "remedy_dosha",
  festival: "festival_ritual",
  generic: "generic",
};

export default function AIAstrologerCTA({
  context = "generic",
  headline,
  subhead,
  currentPage,
  asks,
}: AIAstrologerCTAProps) {
  return (
    <SEOAgentBridge
      intent={CONTEXT_INTENT[context]}
      currentPage={currentPage}
      headline={headline}
      subhead={subhead}
      asks={asks}
    />
  );
}
